module.exports = __webpack_public_path__ + "media/images/flags/RW-5393c1a6085e6cfc8e542e26f0252508.svg";